<template>
  <div v-if="items && items.length > 0" class="table-responsive">
    <b-table :items="items" :fields="fields" :sort-compare="sortCompare">
      <template v-slot:head(invoice_number)="scope">
        <div class="text-nowrap">{{'invoice_nr' | translate}}</div>
      </template>
      <template v-slot:head(document_date)="scope">
        <div class="text-nowrap">{{'invoice_date' | translate}}</div>
      </template>
      <template v-slot:head(s3_invoice_path)="scope">
        <div class="text-nowrap">{{'bills' | translate}}</div>
      </template>
      <template v-slot:head(s3_csv_path)="scope">
        <div class="text-nowrap">{{'itemized_bill' | translate}}</div>
      </template>
      <template v-slot:cell(s3_invoice_path)="row">
        <a
          class="btn btn-success btn-sm"
          :href="row.item.s3_invoice_path" target="_blank"
        >
          <i class="fa fa-cloud-download mr-5"></i>{{'pdf_download' | translate}}
        </a>
        <a
          class="btn btn-success btn-sm"
          v-if="row.item.s3_sum_csv_path!=''"
          :href="row.item.s3_sum_csv_path" target="_blank"
        >
          <i class="fa fa-cloud-download mr-5"></i>{{'download_sum_csv' | translate}}
        </a>
      </template>
      <template v-slot:cell(s3_csv_path)="row">
        <a
          class="btn btn-success btn-sm"
          :href="row.item.s3_csv_path"
          target="_blank">
          <i class="fa fa-cloud-download mr-5"></i>{{'csv_download' | translate}}
        </a>
      </template>
    </b-table>
  </div>
  <div v-else>
    <div class="callout callout-info">
      <h4>
        <i class="fa fa-exclamation-triangle mr-5"></i>{{'info' | translate}}
      </h4>
      <p>{{'no_invoices' | translate}}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: ['items'],
  data () {
    return {
      fields: ['invoice_number', {key: 'document_date', sortable: true}, 's3_invoice_path', 's3_csv_path'],
      sortBy: 'document_date',
      sortDirection: 'asc'
    }
  },
  methods: {
    sortCompare (aRow, bRow, key) {
      const a = aRow[key]
      const b = bRow[key]
      let c = a.split('.')
      let d = b.split('.')
      if (c[2] < d[2]) {
        return -1
      }
      if (c[1] < d[1]) {
        return -1
      }
      if (c[0] < d[0]) {
        return -1
      }
      return 1
    }
  },
  mounted () {
  },
  watch: {
    model () {
      this.items = []
    },
    language () {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/Tables/SapInvoicesTable.vue